export var ACTIONS;
(function (ACTIONS) {
    ACTIONS["CHANGE_DATA"] = "CHANGE_DATA";
    ACTIONS["NEW_CHAT_MESSAGE"] = "NEW_CHAT_MESSAGE";
})(ACTIONS || (ACTIONS = {}));
